import { isEmpty } from "lodash";
import { IDraggableAlignmentResult, ISectionGroup, SectionGroup } from "store/types";
import { getUser } from "./Cookies";

export const hasUnsortedContent = (draggableContent: IDraggableAlignmentResult | undefined) => {
  const unsorted = draggableContent?.sectionGroups.find(
    (sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.UNSORTED,
  );
  if (unsorted && !isEmpty(unsorted.sections)) {
    return true;
  }
  return false;
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const isAdminUser = (adminIds: string[]) => {
  const user = getUser();
  if (user) {
    return adminIds.map((email: string) => email.toLowerCase()).includes(user.email.toLowerCase());
  }
  return false;
};
